import styles from './styles.module.scss';
import { PropTypes } from 'prop-types';

const Label = ({ children, htmlFor }) => (
  <label className={styles.label} htmlFor={htmlFor}>{children}</label>
);

Label.propTypes = {
  children: PropTypes.node,
  htmlFor: PropTypes.string
};

export default Label;
